"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _hooks = require("@alycecom/hooks");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _ImportDropZone = _interopRequireDefault(require("../ImportDropZone"));

var _ContactsPreviewForm = _interopRequireDefault(require("../ContactsPreviewForm"));

var _StepperFooter = _interopRequireDefault(require("../../../../components/Stepper/StepperFooter"));

var _createBatchStep = require("../../../../store/ui/createBatchStep");

var BulkUploadPanel = function BulkUploadPanel() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isImportStep = (0, _reactRedux.useSelector)(_createBatchStep.getIsCreateBatchStepUploadFile);
  var isPreviewStep = (0, _reactRedux.useSelector)(_createBatchStep.getIsCreateBatchStepContactsPreview);

  var _useModalState = (0, _hooks.useModalState)(),
      isOpen = _useModalState.isOpen,
      handleOpen = _useModalState.handleOpen,
      handleClose = _useModalState.handleClose;

  var goBackToFileUploadStep = (0, _react.useCallback)(function () {
    dispatch((0, _createBatchStep.setCreateBatchStep)(_createBatchStep.CreateBatchStep.FileUpload));
  }, [dispatch]);
  var handleSubmitResetContacts = (0, _react.useCallback)(function () {
    handleClose();
    goBackToFileUploadStep();
  }, [handleClose, goBackToFileUploadStep]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1
  }, isImportStep && /*#__PURE__*/_react.default.createElement(_ImportDropZone.default, null), isPreviewStep && /*#__PURE__*/_react.default.createElement(_ContactsPreviewForm.default, null, function (_ref) {
    var isLoading = _ref.isLoading,
        isValid = _ref.isValid,
        isDirty = _ref.isDirty;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_StepperFooter.default, {
      isLoading: isLoading,
      disabled: isLoading || !isValid && !isDirty,
      onClickBack: handleOpen
    }), /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, {
      width: "100%",
      variant: "warning",
      isOpen: isOpen,
      title: "Are you sure you want to delete the imported contacts?",
      onSubmit: handleSubmitResetContacts,
      onDiscard: handleClose,
      submitButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
      backdropStyles: {
        top: 0
      },
      DialogProps: {
        disablePortal: false
      }
    }));
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(BulkUploadPanel);

exports.default = _default;